// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3dQWd","alertIcon":"ConfirmModal_alertIcon__144yV"};